<style scoped>
	.plan-card .button[disabled]:hover,
	.plan-card .button.disabled:hover {
		cursor: not-allowed;
	}

	.plan-comparison {
		max-width: calc(50% - .5rem);
	    min-width: calc(50% - .5rem);
	    width: calc(50% - .5rem);
	}

	.plan-comparison .button.disabled {
		/* color: #333; */
		/* opacity: 1; */
	}
	.plan-comparison .button.disabled:hover {
		cursor: default;
	}
	.plan-cards {
		/* min-height: 389px; */
	}
	.plan-card {
		cursor: pointer;
		box-sizing: border-box;
		border-width: 2px;
		width: calc(25% - .75em);
	}
	.dark .plan-card {
		border-color: #333;
	}
	.plan-card:nth-child(5), .plan-card:nth-child(6), .plan-card:nth-child(7) {
		max-width: calc(25% - .75em);
		margin-top: 1em;
	}
	.plan-card:nth-child(5)  {
		margin-left: 0;
	}
	.plan-card.hidden + .plan-card,
	label[style*='display: none'] + .plan-card {
		margin-left: 0;
	}
	/* .plan-card:not(.strikethrough):not(.selected):hover {
		border-color: #bbb;
	}
	.plan-card:not(.strikethrough):not(.selected):hover i {
		color: #bbb;
	} */
	.strikethrough .badge {
		visibility: hidden;
	}
	.plan-card.strikethrough {
		cursor: not-allowed;
	}
	.plan-card.strikethrough i {
		display: none;
	}
	.plan-card.single {
		width: 100%;
	}
	.plan-card > header > h1 {
		margin-top: 0;
	}
	.plan-card > header {
		margin-bottom: 1.5em;
	}
	.plan-card i {
		font-size: 1.2em;
		color: #ddd;
	}

	.plan-card.review-change i {
		display: none;
	}
	.plan-card.plan-card-primary {
		border-width: 2px;
	}
	.plan-card.selected {
		border-color: #2E88D6;
	}

	.review-change.plan-card {
		border-color: #DDD;
	}

	.plan-card.selected i {
		color: #2E88D6;
	}

	.review-change .plan-card.plan-card-primary.selected {
		border-color: #DDD;
	}

	.plan-card > h2 {
		margin-top: 0;
	}

	.plan-card.selected i {
		display: block;
	}
	.plan-features {
		text-align: left;
		margin: 0 0 3rem;
	}
	.plan-features li i:not(.success):not(.error),
	.plan-card.selected i {
		color: #2E88D6;
	}
	.plan-comparison .current-plan .plan-features li i:not(.success):not(.error){
		color: #777;
	}
	.plan-features li .bullet-margin {
		width: 1.5rem;
		text-align: left;
	}
	.plan-features li {
		line-height: 1.4rem;
		margin-bottom: .5rem;
	}
	.strikethrough {
		text-decoration: strikethrough;
		color: #999;
	}
	.strikethrough.selected i{
		display: none;
	}
	.plan-features li.strikethrough i.fas {
		color: #ddd;
	}
	.plan-features > .column {
		width: 50%;
	}
	footer.choose-plan.row {
		margin-left: auto;
		width: 50%;
	}
	footer.choose-plan.row button {
		margin-left: auto;
		width: calc(50% - .5em);
	}


	.review-change .button.success.active + .button.success.active {
		display: none;
	}
	.billing-options.row .button {
		width: 100%;
	}
	.plan-option:first-of-type {
		margin-top: auto;
	}
	.annual.badge {
		position: absolute;
		top: -.5rem;
		right: .5rem;
	}
	.plan-comparison .current-plan:not(.new-plan) .annual.badge {
		display: none;
	}
	.button {
		overflow: visible;
		text-align: center;
	}
	.button.active:before {
		content: '\f00c';
		font-family: 'Font Awesome 5 Free';
		font-weight: 900;
		position: absolute;
		left: 1rem;
	}
 	.button.new.active:before {
		color: #2E88D6;
	}
	.button.success.new.active:before {
		color: #fff;
	}
	.button.button-stacked {
		display: flex;
		text-align: left;
		padding-left: 3em;
	}
	h1.total {
		margin: 0;
	}
	h2 {
		line-height: 1.4em;
	}
	.tabs > .tab {
		width: 100%;
		text-align: center;
	}
	.redeem-code .field {
		margin-top: 1em;
	}
	.redeem-code {
		margin: auto;
		width: 100%;
		max-width: 425px;
	}

	.extension {
		margin-top: 1rem;
		min-height: 118px;
	}
	.half-width {
		max-width: calc(50% - .5rem);
		min-width: calc(50% - .5rem);
		width: calc(50% - .5rem);
	}
	.cost-summary {
		height: 86px;
		max-width: calc(50% - .5rem);
	    min-width: calc(50% - .5rem);
	    width: calc(50% - .5rem);
	}
	.change-summary {
		padding-right: 5rem;
		width: 50%;
	}
	.change-summary ul,
	.change-summary ul ul {
		list-style-type: none;
	}

	.payment-notice {
		margin: 0;
	}

	section {
		margin-bottom: 2rem;
	}

	footer.row button {
		width: 100%;
	}

	footer .payment-notice + footer {
		margin-top: 2rem;
	}

	.notice a {
		font-weight: bolder;
	}

	.popover-target-wrapper i.mouseover {
		color: #bbb !important;
	}

	.dark .popover-target-wrapper i.mouseover {
		color: #555 !important;
	}

	.extension-header {
		padding: 1em 0 0;
	}

	.extension-header button {
		border: 0;
		box-shadow: none;
		background-color: transparent !important;
	}

	.extension-header h3 {
		margin-bottom: 0;
	}

	.choose-extension {
		width: 200px;
	}

	.shift-end {
		justify-content: flex-end;
	}

	.self-service {
		flex: 0 0 0;
		margin-bottom: 2em;
	}

	.margin-bottom {
		margin-bottom: 1em;
	}

	.link {
		text-decoration: none;
	}
	@media only screen and (max-width : 1120px) {
		.plan-cards {
			width: 100%;
			box-sizing: border-box;
			flex-wrap: wrap;
		}

		.change-summary {
			width: 100%;
			padding-right: 0;
		}

		/* .row.separated-extra > .plan-comparison {
			min-width: 100%;
			margin-left: 0;
		} */

		.review-change {
			flex-direction: column;
		}

		.plan-card {
		    box-sizing: border-box;
		}

		.change-plan-wrapper > header {
			background: white;
			position: sticky;
			top: 0;
			z-index: 2;
			padding: 1rem 0;
			box-sizing: border-box;
		}
		.dark .change-plan-wrapper > header {
			background: #1a1a1a;
		}
	}

	@media (min-width : 640px) and (max-width : 1120px) {
		.plan-card:not(.review-change) {
			min-width: calc(50% - .5rem);
			max-width: calc(50% - .5rem);
		    box-sizing: border-box;
			margin-left: 0;
		}

		.plan-card:nth-child(even) {
			margin-left: 1rem;
		}

		.plan-card:nth-child(odd) {
			margin-left: 0;
		}

		.plan-card:nth-child(n+3) {
			margin-top: 1rem;
		}
	}

	@media only screen and (max-width : 799px) {
		.plan-comparison footer.row {
			flex-direction: column;
		}
		.plan-comparison footer.row.separated-extra .flexible + .flexible {
			margin-top: 1em;
			margin-left: 0;
		}
	}

	@media only screen and (max-width : 639px) {
		.plan-features.row {
			flex-direction: column;
		}

		.plan-features > .column{
			width: 100%;
			margin-left: 0;
		}

		.change-plan-wrapper > header.row,
		.change-plan-wrapper > div.row {
			flex-direction: column;
		}

		.row.separated .flexible.cost-summary {
			min-width: 100%;
			margin-left: 0 !important;
		}

		.plan-comparison {
			min-width: 100%;
			margin-left: 0;
		}

		.row.separated-extra > * + .plan-comparison {
			margin-left: 0;
		}

		.plan-cards {
			flex-direction: column;
		}

		.plan-card {
			width: 100%;
		}

		.plan-card + .plan-card {
			margin-top: 1rem;
			margin-left: 0;
		}

		.review-change footer.row {
			flex-direction: column-reverse;
		}

		.review-change footer.row button + button {
			margin-left: 0;
			margin-bottom: 1rem;
		}

		footer.choose-plan.row button {
			width: 100%;
		}
	}

	@media only screen and (max-width : 415px) {
		.cost-summary h4 {
			margin-bottom: .25rem;
			white-space: nowrap;
		}
		.cost-summary h1 {
			margin-top: 1em;
		}
	}

	@media only screen and (min-width : 600px) and (max-width : 775px) {
		.cost-summary h4 {
			margin-bottom: .25rem;
			white-space: nowrap;
		}
		.cost-summary h1 {
			margin-top: 1em;
		}
	}

</style>


<template>
	<div class="column flexible detail-page content content-1100 scope">
		<header class="column">
			<div class="row centering separated">
				<button class="link" title="Go to Account Home" @click="leavePlan" type="button" name="button"><i class="fas fa-arrow-left"></i></button>
				<h1-placeholder :text="'TekScope Subscription'" v-if="subscriptionLoading"></h1-placeholder>
				<h1 class="gap" v-else>
					Your TekScope Subscription
				</h1>
			</div>
		</header>
		<div v-if="notFoundError" class="notice error">
			{{ notFoundError }}
		</div>
		<div v-if="genericError">
			{{ genericError }} If this happens again, <a href="mailto:scope@support.tekcloud.com?subject=Error%20Viewing%20Subscription">let us know</a>.
		</div>
		<div v-else class="column change-plan-wrapper separated-extra">
			<header class="row rigid separated centering">
				<div v-if="subscriptionLoading" class="flexible row separated-extra baseline">
					<h2-placeholder :text="'Your Plan'"></h2-placeholder>
				</div>
				<div v-else class="flexible row separated-extra baseline">
					<h2 class="rigid"><span :class="{muted: selectedLicenseExtension}">{{currentPlanName}}</span> <span v-if="selectedLicenseExtension">/ License Extension </span></h2>
				</div>
				<!-- prepaid summary
				free trial summary  -->

				<div :class="{invisible:subscriptionLoading}" class="flexible card card-secondary row centering cost-summary">
					<div v-if="current" class="flexible">

						<!-- is prepaid plan -->
						<div class="row centering separated flexible" v-if="current.isPrepaid">
							<div v-if="current.isPerpetual" class="flexible">
								<div class="column separated" v-if="selectedLicenseExtension">
									<h4 class="flexible">
										<div v-if="couponCodeModel">Prepaid License</div>
										<div v-else>Due now</div>
									</h4>
									<small class="rigid gray-6">
										Extends updates to {{selectedLicenseExtension.maintenanceEnds || selectedLicenseExtension.newExpiration | date}}
									</small>
								</div>
								<div class="column separated" v-else>
									<h4 class="flexible" v-if="potentialSelfServiceExtension">
										Software updates end {{  potentialSelfServiceExtension.newExpiration | date  }}
									</h4>
									<h4 class="flexible" v-else-if="current.maintenancePeriod.expiration">
										Software updates end {{  current.maintenancePeriod.expiration | date  }}
									</h4>
									<h4 class="flexible" v-else>
										<!-- Placeholder text? -->
									</h4>
									<small class="gray-6 row rigid"><div class="badge badge-hollow trailing-off" :title="current.prepaidDisplayCode">{{current.prepaidDisplayCode}}</div></small>
								</div>
							</div>
							<div v-else class="column separated flexible">
								<h4 class="flexible">
									Expires {{current.expiry | date}}
								</h4>
								<span class="rigid">
									<small class="gray-6 row rigid"><div class="badge badge-hollow trailing-off" :title="current.prepaidDisplayCode">{{current.prepaidDisplayCode}}</div></small>
								</span>
							</div>
							<h1 class="total rigid">
								<strong v-if="extensionMethod === 'self-service' && potentialSelfServiceExtension && potentialSelfServiceExtension.isSelfService">{{potentialSelfServiceExtension.totalPrice | currency(true)}}</strong>
								<strong v-else>Prepaid</strong>
							</h1>
						</div>
						<!-- is promo plan -->
						<div class="row centering separated flexible" v-else-if="current.isPromo || current.isBasic && !currentPlan.isBasic">
							<div class="column separated flexible">
								<h4 v-if="current.renews" class="flexible">
									Renews {{current.expiry | date}}
								</h4>
								<h4 v-else class="flexible">
									Ends {{current.expiry | date}}
								</h4>
								<small class="rigid" :class="{'invisible':!paymentMethodLoaded}">
									<span class="row centering separated" v-if="account.paymentMethod && current.plan.displayName !== 'Free'">
										<toggle-switch tabindex="0" @change="onRenewalChange" v-model="subRenews" :disabled="submitting"></toggle-switch>
										<span class="gray-6 rigid">Auto-renews</span>
										<span class="gray-6 rigid" v-if="toggling"><i class="fas fa-spinner fa-spin"></i></span>
									</span>
									<span v-else-if="current.plan.displayName === 'Free'">Renews in 6 months</span>
									<router-link v-else class="row rigid" :to="{ path: `/payments/method?returnPath=%2Fsubscriptions%2Fscope%2f${current.id}` }" >Add a card to auto-renew</router-link>
								</small>
							</div>
							<div class="rigid column">
								<h1 class="total rigid">
									<strong>{{currentPlan.amount | currency(true) || 0}}</strong>
								</h1>
								<small v-if="currentPlan.amount" class="gray-6 text-right">Plus tax</small>
							</div>
						</div>

						<!-- is current free trial -->
						<div class="row centering flexible" v-else-if="current.isTrial">
							<div class="column separated flexible">
								<h4 class="flexible">
									Expires {{current.expiry | date}}
								</h4>
								<small class="gray-6 rigid">Won't auto-renew</small>
							</div>
							<h1 class="total rigid">
								<strong>Trial</strong>
							</h1>
						</div>

						<div class="row centering flexible" v-else>
							<div class="column separated flexible">
								<h4 class="flexible">
									Renews {{current.expiry | date}}
								</h4>
								<small class="gray-6 rigid">Won't expire</small>
							</div>
							<h1 class="total rigid">
								<strong>Free</strong>
							</h1>
						</div>

					</div>
				</div>
			</header>

			<scope-sub-placeholder v-if="subscriptionLoading" :plan-items="1" :package-items="1"></scope-sub-placeholder>

			<div v-else-if="selectedLicenseExtension" class="row separated-extra">
				<div class="change-summary">
					<!-- extend maintenance license -->
					<ul class="column">
						<li class="rigid">
							<h2 v-if="selectedLicenseExtension.isSelfService">You’ve chosen the {{  selectedLicenseExtension.extensionLength }} <em>{{ selectedLicenseExtension.category }}</em> License Extension.</h2>
							<h2 v-else>You’ve chosen to redeem a license extension through a prepaid code.</h2>
						</li>
						<li class="rigid">
							<h2>What happens next?</h2>
							<ul class="bullets">
								<li class="bullet">
									<div class="bullet-margin"><i class="fas fa-angle-double-right"></i></div>
									<div class="bullet-content">You will have access to the lastest version updates until your license term ends</div>
								</li>
							</ul>
						</li>
					</ul>
				</div>

				<!-- review plan -->
				<form v-if="couponDetails" class="column flexible separated-extra plan-comparison" @submit.prevent="onSubmitPrepaidExtension">
					<section class="row flexible plan-cards">

						<div v-if="couponDetails" class="column flexible separated-extra">
							<div  class="plan-card single plan-card-primary coupon-details">
								<h2 class="capitalize">{{couponDetails.planWithContext}}</h2>
								<h3 class="no-margin row separated">
									<span class="rigid"><small>Prepaid</small></span>
								</h3>
							</div>
							<div class="rigid">
								<div class="table rigid">
									<div class="row">
										<div class="gap label">
											Prepaid Code
										</div>
										<footer class="value rigid">
											<span class="badge badge-hollow">{{couponCodeModel}}</span>
										</footer>
									</div>
								</div>
							</div>
						</div>
					</section>

					<footer class="column separated-extra">
						<div v-if="changeSubscriptionError" class="row rigid">
							<div v-if="changeSubscriptionError" class="notice error flexible">
								<div v-if="changeSubscriptionError.type === 'StripeCardError'">
									{{changeSubscriptionError.message}}
								</div>
								<div v-else-if="changeSubscriptionError.type === 'PAYMENT_GATEWAY_ERROR'">
									There was an error processing your transaction.
								</div>
								<div v-else-if="changeSubscriptionError.message === 'Cannot extend maintenance for this duration.'">
									{{ changeSubscriptionError.message }}
								</div>
								<div v-else>
									There was an error creating your subscription.
								</div>
							</div>
						</div>
						<!-- </footer> -->
						<footer class="row flexible separated-extra right">
							<button @click="resetState" type="button" class="flexible">Cancel</button>
							<button :disabled="submitDisabled" type="submit" class="primary flexible">
								<span v-if="submitting"><i class="fas fa-spinner fa-spin"></i></span>
								<span v-else>Redeem</span>
							</button>
						</footer>
					</footer>
				</form>

				<!-- Self-Service Extension -->

				<form v-else class="column flexible separated-extra plan-comparison" @submit.prevent="purchaseExtension">
					<section class="row flexible plan-cards">
						<div v-if="!couponDetails && selectedLicenseExtension" class="column flexible separated-extra">
								<div  class="plan-card self-service single plan-card-primary">
									<h2 class="capitalize">{{ selectedLicenseExtension.extensionLength }} - {{ selectedLicenseExtension.category }}</h2>
									<h3 class="no-margin row separated">
										<span class="rigid"><small>{{  selectedLicenseExtension.totalPrice | currency(true)  }}</small></span>
									</h3>
								</div>
								<div class="column separated-extra">
									<PaymentNotice
										:returnPath="'/subscriptions/scope/' + current.id"
										:model="account.paymentMethod"
										:loading="!paymentMethodLoaded"
									/>
									<EstimatedCost
									:loading="loadingTaxInfo"
									v-if="selectionCost"
									:cost="estimatedCost"
									/>
								</div>
							</div>
					</section>

					<footer class="row flexible separated-extra right margin-bottom">
						<button @click="resetState" type="button" class="flexible">Cancel</button>
						<button :disabled="submitDisabled" type="submit" class="primary flexible">
							<span v-if="submitting"><i class="fas fa-spinner fa-spin"></i></span>
							<span v-else>Confirm and Pay</span>
						</button>
					</footer>

					<div class="column separated-extra">
						<div v-if="changeSubscriptionError" class="row rigid">
							<div v-if="changeSubscriptionError" class="notice error flexible">
								<div v-if="changeSubscriptionError.type === 'StripeCardError'">
									{{changeSubscriptionError.message}}
								</div>
								<div v-else-if="changeSubscriptionError.type === 'PAYMENT_GATEWAY_ERROR'">
									There was an error processing your transaction.
								</div>
								<div v-else-if="changeSubscriptionError.type === 'NOT_FOUND'">
									There was an error processing your transaction.
								</div>
								<div v-else-if="changeSubscriptionError.message === 'POLLING_ERROR'">
									There was an error processing your payment. Please reach out to support.
								</div>
								<div v-else-if="changeSubscriptionError.message === 'Cannot extend maintenance for this duration.'">
									{{ changeSubscriptionError.message }}
								</div>
								<div v-else>
									There was an error creating your subscription.
								</div>
							</div>
						</div>
					</div>

					<div v-if="selfServiceSuccess" class="notice success">Purchase successful. Redirecting...</div>

				</form>
			</div>

			<!-- prepaid plan -->
			<div class="column separated-extra" v-else-if="current">
				<!-- License extension -->
				<section v-if="current.isPerpetual">
					<!-- Prepaid Extension -->

					<div class="extension-header row centering">
						<h3 class="flexible">License Extension</h3>
						<div v-if="current.extensionOptions && current.extensionOptions.length > 0">
							<button class="link" v-if="extensionMethod === 'self-service'" @click="changeExtensionMethod('prepaid')">Reedem Code</button>
							<button class="link" v-else @click="changeExtensionMethod('self-service')">Purchase an Extension</button>
						</div>
					</div>
					<!-- TODO: Toggle bool to swap between code and self-service flows -->
					<div v-if="extensionMethod === 'prepaid'" class="plan-card single extension">
						<div class="single plan-card-primary">
							<div class="flexible redeem-code separated column">
								<label>
									<span class="label">Prepaid Code</span>
									<redeem-code-input :coupon-applied="couponApplied" :processing="processingCode" v-on:on-submit-code="onSubmitCode" :value="couponCodeModel"></redeem-code-input>
								</label>
								<div v-if="couponDetailsError">
									<blockquote v-if="couponDetailsError" class="notice" :class="{'warning':invalidCouponType || invalidCouponTier, 'error':!invalidCouponType && !invalidCouponTier}">
										<button type="button" class="close link centered" @click="resetCouponState">×</button>
										<span>
											<span v-if="invalidCouponType">This code will not work to extend your license.</span>
											<span v-else-if="invalidCouponTier">Your extension tier doesn't match your {{currentPlanName}} plan.</span>
											<span v-else>This code didn't work.</span>
											<br>
											If you think it should, <a href="mailto:scope@support.tekcloud.com?subject=Error%20Redeeming%20Code">let us know</a>.
										</span>
									</blockquote>
								</div>
							</div>
						</div>
					</div>

					<SelfServiceMaintenanceOptions v-else-if="extensionMethod === 'self-service'" :current="current" @extension="setSelfServiceExtension" />

				</section>

				<section v-if="selection.isUltimate || selection.isPro">
					<!-- <div class="row"> -->
					<h3 class="flexble">Package<span v-if="selection.isUltimate">s</span></h3>
					<!-- </div> -->
					<div class="rigid row plan-cards packages">
						<label class="plan-card gap selected" v-for="(proPackage, index) in proPackages" v-bind:key="index" v-show="selection.isUltimate || selection.isPro && proPackage.id === currentPlan.id">
							<input type="radio" hidden :value="proPackage.id" :disabled="selection.tierName !== 'Professional'" v-model="selectedPackage" :checked="selectedPackage === proPackage.id"/>
							<header class="row baseline separated">
								<h3 class="plan-title flexible">{{proPackage.name}}</h3>
								<i class="fas fa-check-circle"></i>
								<!-- <span v-if="plan.name === currentPlanName" class="badge badge-muted rigid">Current</span>
								<span v-else-if="newTrial" class="badge badge-mono badge-success rigid">Trial</span>
								<span v-else-if="plan.name === selectionName" class="badge badge-mono badge-info rigid">New</span> -->
							</header>
							<div class="gray-6">{{proPackage.description}}</div>
						</label>
					</div>

				</section>
				<section v-else-if="selectionHasAddOns">
					<h3>Packages</h3>
					<div class="rigid row plan-cards flowing packages">
						<label class="plan-card gap selected" v-for="(addOn, index) in selection.addOnPackages" v-bind:key="index">
							<header class="row baseline separated">
								<h3 class="plan-title flexible">{{addOn.name}}</h3>
								<i class="fas fa-check-circle"></i>
								<!-- <span v-if="plan.name === currentPlanName" class="badge badge-muted rigid">Current</span>
								<span v-else-if="newTrial" class="badge badge-mono badge-success rigid">Trial</span>
								<span v-else-if="plan.name === selectionName" class="badge badge-mono badge-info rigid">New</span> -->
							</header>
							<div class="gray-6">{{addOn.description}}</div>
						</label>
					</div>
				</section>

				<h3>Features</h3>
				<ul class="plan-features row separated-extra">
					<div class="column flexible">
						<li v-for="(feature, index) in selection.featureList1" v-bind:key="index" class="bullet" :class="{'hidden': feature.notSupported}">
							<div class="bullet-margin"><i class="fas fa-check"></i></div>
							<div class="bullet-content column">{{feature.description}}
								<small class="links popover-target-wrapper" v-if="(!feature.notSupported) && feature.requiresPrereq">
									<a target="_blank" :href="scopePrereqUrl">Install Instructions</a>
									<popover
										class="left rigid"
										:message="'This feature requires prerequisite software. See Install Instructions for more information.'">
										<i slot="popover-target" class="fas fa-info-circle mouseover"></i>
									</popover>
								</small>
							</div>
						</li>
					</div>
					<div class="column flexible">
						<li v-for="(feature, index) in selection.featureList2" v-bind:key="index" class="bullet" :class="{'hidden': feature.notSupported}">
							<div class="bullet-margin"><i class="fas fa-check"></i></div>
							<div class="bullet-content column">{{feature.description}}
								<small class="links popover-target-wrapper" v-if="!feature.notSupported && feature.requiresPrereq">
									<a target="_blank" :href="scopePrereqUrl">Install Instructions</a>
									<popover
										class="left rigid"
										:message="'This feature requires prerequisite software. See Install Instructions for more information.'">
										<i slot="popover-target" class="fas fa-info-circle mouseover"></i>
									</popover>
								</small>
							</div>
						</li>
					</div>
				</ul>

				<div v-if="current.isPerpetual" class="row shift-end">
					<button type="button" v-if="extensionMethod === 'self-service' && current.type !== 'Free'" class="primary rigid end choose-extension" :disabled="!potentialSelfServiceExtension" @click="chooseExtension">Choose Extension</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import capitalize from '../filters/capitalize';
import currency from '../filters/currency';
import byte from '../filters/byte';
import duration from '../filters/duration';
import date from '../filters/date';
import { scrollTo } from '../directives/scroll-to';
import PaymentNotice from '../components/PaymentNotice';
import EstimatedCost from '@/components/EstimatedCost';
import taxUtil from '@/modules/tax-util';
import RedeemCodeInput from '@/components/RedeemCodeInput';
import Popover from '../components/Popover';
import Spinner from '../components/Spinner';
import ToggleSwitch from '../components/ToggleSwitch';
import ScopeSubPlaceholder from '../components/ScopeSubPlaceholder';
import H1Placeholder from '../components/H1Placeholder';
import H2Placeholder from '../components/H2Placeholder';
import TablePlaceholder from '../components/TablePlaceholder';
import TrialBadge from '@/components/TrialBadge';
import { mapGetters, mapState, mapActions } from 'vuex';
import SelfServiceMaintenanceOptions from '@/components/SelfServiceMaintenanceOptions.vue';

export default {
	name: 'ScopeSubEdit',
	filters: {
		currency,
		date,
		capitalize,
		byte,
		duration
	},
	directives: {
		scrollTo
	},
	components: {
		PaymentNotice,
		EstimatedCost,
		RedeemCodeInput,
		Spinner,
		ScopeSubPlaceholder,
		H1Placeholder,
		H2Placeholder,
		TablePlaceholder,
		Popover,
		TrialBadge,
		ToggleSwitch,
		SelfServiceMaintenanceOptions,
	},
	data() {
		return {
			touched: false,
			previousIntervalId: null,
			submitting: false,
			processingCode: false,
			toggling: false,
			// currentPlan: null,
			useTrial: false,
			selectedId: null,
			selectedLicenseId: null,
			// plans: [],
			subscriptionLoading: false,
			getSubscriptionError: null,
			changeSubscriptionError: null,
			showConfirmation: false,
			showMaintenancePlans: false,
			showRedeemCodeInput: false,
			couponCodeModel: '',
			couponDetailsError: null,
			couponDetails: null,

			notFoundError: null,
			genericError: null,

			potentialSelfServiceExtension: null,
			extensionMethod: 'self-service', // self-service || prepaid
			selfServiceSuccess: false,
		};
	},
	computed: {
		...mapGetters({
			account: 'account',
			scopeAppUrl: 'auth/scopeAppUrl',
			scopePrereqUrl: 'auth/scopePrereqUrl',
			installTekScopeUrl: 'auth/installTekScopeUrl',
		}),
		...mapState({
			estimatedTax(state) {
				return state.account.estimatedTax;
			},
			loadingTaxInfo(state) {
				return state.account.loadingTaxInfo;
			}
		}),
		...mapState('scope', {
			selection: 'selection',
			subRenews: 'subscriptionRenews',
			current: 'currentSubscription',
			selectedLicenseExtension: 'selectedLicenseExtension',
			planCards: 'planCards',
			plans: 'plans',
			proPackages: 'proPackages',
			plansMap: 'plansMap',
		}),
		selectedPackage: {
			get() {
				return this.$store.state.scope.selectedPackage;
			},
			set(value) {
				this.$store.dispatch('scope/SET_PACKAGE', value);
			},
		},
		selectedLicenseExtension: {
			get() {
				return this.$store.state.scope.selectedLicenseExtension;
			},
			set(value) {
				this.$store.dispatch('scope/SET_LICENSE_EXTENSION', value);
			},
		},
		...mapState('subscription', {
			changeSubscriptionStatus: 'changeSubscriptionStatus',
			redirectToScope: 'redirectToScope'
		}),
		...mapState('auth', [
			'refreshToken'
		]),
		selectionId(){
			return this.selection && this.selection.id;
		},
		selectionName(){
			return this.selection && this.selection.name;
		},
		currentPlan(){
			return this.current && this.current.plan && this.plansMap[this.current.plan.id];
		},
		currentPlanName() {
			return this.currentPlan && (this.currentPlan.tierName === "Professional" ? this.currentPlan.tierName + ' - ' + this.plansMap[this.currentPlan.id].name : this.currentPlan.tierName);
		},
		isPrepaidPlan() {
			return this.current && this.current.type === 'Prepaid';
		},
		selectionHasAddOns() {
			return this.selection.addOns && this.selection.addOns.length;
		},
		prepaidPlan() {
			return this.isPrepaidPlan && this.currentPlan;
		},
		processing() {
			return this.subscriptionLoading || this.changeSubscriptionStatus.loading || this.submitting;
		},
		redirectReason() {
			return this.$route.query && this.$route.query.r;
		},
		paymentMethodLoaded() {
			return this.account.paymentMethod !== undefined;
		},
		submitDisabled() {
			return this.processing || (this.paymentRequired && !this.account.paymentMethod);
		},
		estimatedCost() {
			// wait for a new non-trial/free plan and estimatedTax before calculating
			return this.selectedLicenseExtension && this.estimatedTax ? taxUtil.calculateTax(this.selectedLicenseExtension.amount, this.estimatedTax.taxRatePercentage) : null;
		},
		selectionCost() {
			let selection = this.selectedLicenseExtension;

			if (!selection || !selection.totalPrice || !selection.amount) {
				return 0;
			}
			return selection.totalPrice || selection.amount;
		},
		couponApplied() {
			return this.couponDetails != null;
		},
		invalidCouponType() {
			return this.couponDetailsError === 'INVALID_COUPON_TYPE';
		},
		invalidCouponTier() {
			return this.couponDetailsError === 'INVALID_COUPON_TIER';
		}
	},
	methods: {
		...mapActions('subscription', {
			clearStoredSelection: 'CLEAR_SELECTION',
			purchaseExtensionAndPollStatus: 'PURCHASE_EXTENSION_AND_POLL_STATUS'
		}),
		purchaseExtension() {
			this.submitting = true;
			const subscriptionId = this.current.id;
			const maintenanceExtensionId = this.selectedLicenseExtension.id;
			const quantity = this.selectedLicenseExtension.quantity;
			return this.purchaseExtensionAndPollStatus({ subscriptionId, maintenanceExtensionId, quantity })
				.then(() => {
					this.submitting = false;
					this.selfServiceSuccess = true;
					window.location.href = this.installTekScopeUrl + `&r=maintenance&subid=${this.current.id}`;
				}, (reason) => {

					this.submitting = false;
					this.changeSubscriptionError = reason;
				});
		},
		setSelfServiceExtension(extension) {
			this.potentialSelfServiceExtension = extension;
		},
		changeExtensionMethod(method) {
			this.extensionMethod = method;
		},
		chooseExtension() {
			this.selectedLicenseExtension = this.potentialSelfServiceExtension;
		},
		setPackageSelection(proPackage) {
			const selectedPackage = proPackage.id;
			this.useTrial = proPackage.hasTrial;

			this.$store.dispatch('scope/SET_PACKAGE', selectedPackage);
			this.$store.dispatch('scope/SET_SELECTION', { selection: proPackage });//, selectedPackage });
		},
		selectPrepaidLicenseExtension(coupon) {
			this.selectedLicenseExtension = coupon;
		},
		onSubmitCode(couponCode) {
			let vm = this;
			this.couponCodeModel = couponCode;
			this.processingCode = true;
			this.$store.dispatch('coupon/GET_MAINTENANCE_COUPON_DETAILS', {couponCode, currentSub: this.current})
				.then(response => {
					this.processingCode = false;
					this.couponDetails = response;
					this.selectPrepaidLicenseExtension(response);
				})
				.catch(error => {
					this.couponDetailsError = error;
					this.processingCode = false;
				});
		},
		displayRedeemCode() {
			this.showRedeemCodeInput = true;
		},
		setTierSelection(selectedPlan){
			if (!selectedPlan) {
				return;
			}

			let selectedPackage = this.selectedPackage;

			// find package to select when professional tier is chosen
			if (selectedPlan.isPro && !selectedPackage) {
				const currentPlan = this.currentPlan;
				selectedPackage = (currentPlan && currentPlan.isPro) ? currentPlan.id : selectedPlan.id;
			}
			// if pro set correct package
			if (selectedPlan.isPro) {
				selectedPlan = this.plansMap[selectedPackage];
			}

			this.useTrial = selectedPlan.hasTrial;

			this.$store.dispatch('scope/SET_PACKAGE', selectedPackage);
			this.$store.dispatch('scope/SET_SELECTION', { selection: selectedPlan });//, selectedPackage });
		},
		onRenewalChange(val) {
			this.toggling = true;
			this.$store.dispatch('scope/SET_RENEWAL_FLAG', val);

			if (this.newPlan) {
				return;
			}

			const patchObj = {};
			if (this.current.isPromo) {
				patchObj.transitionAtEnd = val;
			} else {
				patchObj.cancelAtPeriodEnd = !val;
			}

			this.updateSubscription(patchObj)
				.catch(reason => {
					this.$store.dispatch('scope/SET_RENEWAL_FLAG', !val);
				})
				.finally(()=>{
					this.toggling = false;
				});
		},
		onSubmitPrepaidExtension() {
			const payload = {};

			// if coupon code exists then apply to subscription
			if (this.couponCodeModel !== '') {
				payload.prepaidCouponId = this.couponCodeModel;
			}

			this.updateSubscription(payload)
				.then((sub)=>{
					// goto install screen and display success notice with sub context if necessary
					window.location.href = this.installTekScopeUrl + `&r=maintenance&subid=${sub.id}`;
					return;
				})
				.catch(reason => {
					this.changeSubscriptionError = reason;
				});
		},
		updateSubscription(payload) {
			this.submitting = true;

			const patchObj = payload;
			patchObj.subId = this.current.id;

			return this.$store.dispatch('scope/CHANGE_SUBSCRIPTION_REQUEST', patchObj).then((sub) => {
				this.submitting = false;
				return Promise.resolve(sub);
			}).catch((error) => {
				this.submitting = false;
				return Promise.reject(error);
			});
		},
		deepCopy(obj) {
			return JSON.parse(JSON.stringify(obj));
		},
		getInterval(plan) {
			return (!plan.interval || plan.interval === 'free') ? 'monthly' : plan.interval;
		},
		leavePlan() {
			this.resetState();
			this.$store.dispatch('scope/TEAR_DOWN');
			this.$router.push('/');
		},
		resetState() {
			this.$store.dispatch('scope/RESET_STATE');
			this.changeSubscriptionError = null;
			this.selectedLicenseExtension = null;
			this.resetCouponState();
		},
		resetCouponState() {
			this.couponCodeModel = '';
			this.couponDetailsError = null;
			this.couponDetails = null;
			this.showRedeemCodeInput = false;
		}
	},
	created() {
		let vm = this;
		vm.subscriptionLoading = true;
		vm.$store.dispatch('scope/LOAD_SCOPE_SUB_VIEW',  { subId: vm.$route.params.subId })
			.then((initialPlan)=>{


				// if restoring, initialPlan is null
				if (initialPlan) {
					vm.setTierSelection(initialPlan);
				}

				vm.subscriptionLoading = false;
			})
			.catch(error => {
				if (error.type === 'NOT_FOUND') {
					this.notFoundError = 'There was an error locating this subscription.';
				} else {
					this.genericError = 'There was an error loading this subscription.';
				}
				vm.subscriptionLoading = false;
				vm.getSubscriptionError = error;
				console.error(error);
			});
		if (!vm.redirectToScope) {
			vm.$store.dispatch('subscription/SET_SCOPE_REDIRECT', !!vm.newUser);
		}

	}
};
</script>



// WEBPACK FOOTER //
// ./src/views/ScopeSubView.vue